<template>
    <div>
        <div class="robotNav">
            <div class="robotNav_content">
                <div class="robotNav_content_title"><span><img src="@a/img/sv67.svg"/></span>{{this.$store.getters.robotName}}</div>
                <div class="robotNav_content_txt">
                    <router-link to="/alRobot/myRobotDataAnalysis/myRobotDataAnalysis" active-class="active" class="content_txt_list" >
                        <span><img src="@a/img/sv73.svg"/><img src="@a/img/sv73on.svg"/></span>数据分析</router-link>
                    <router-link to="/alRobot/myRobotChat/myRobotChat" active-class="active" class="content_txt_list">
                        <span><img src="@a/img/sv74.svg"/><img src="@a/img/sv74on.svg"/></span>聊天
                    </router-link>
                    <router-link to="/alRobot/myRobotUserDialog/myRobotUserDialog" active-class="active" class="content_txt_list">
                        <span><img src="@a/img/sv75.svg"/><img src="@a/img/sv75on.svg"/></span>用户对话
                    </router-link>
                    <router-link to="/alRobot/myRobotUserKnowledge/myRobotUserKnowledge" active-class="active" :class="{'active': $route.meta.addKnow}" class="content_txt_list">
                        <span><img src="@a/img/sv76.svg"/><img src="@a/img/sv76on.svg"/></span>知识库
                    </router-link>
                    <router-link to="/alRobot/myRobotSetUp/myRobotSetUp" active-class="active" class="content_txt_list">
                        <span><img src="@a/img/sv77.svg"/><img src="@a/img/sv77on.svg"/></span>设置
                    </router-link>
                    <router-link to="/alRobot/myRobotUserInstall/myRobotUserInstall" active-class="active" class="content_txt_list">
                        <span><img src="@a/img/sv78.svg"/><img src="@a/img/sv78on.svg"/></span>安装
                    </router-link>
                    <router-link to="/alRobot/myRobotAPI/myRobotAPI" active-class="active" class="content_txt_list">
                        <span><img src="@a/img/sv79.svg"/><img src="@a/img/sv79on.svg"/></span>API
                    </router-link>
                </div>
            </div>
            <div class="robotNav_back">
                <a href="#/alRobot" class="notBlue"><img src="@a/img/sv86.svg"/>管理机器人</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "robotNav",
        data() {
            return {
                
            };
        },
        computed: {
            
        },
        methods:{
           
        },
    }
</script>

<style scoped>
    @import "robotNav.css";
</style>